// Wrapped re-export of the @induz/sdk surface used by the YsentinelOne
// dashboards. Every standalone async function is funneled through the shared
// queue (sdkQueue.js) so dashboards don't open dozens of WebSockets at once.
//
// Class exports (ManageUser, Team) are passed through unwrapped — they're
// instantiated and their methods are invoked at mount-time only, so the
// concurrency cost is small. Wrapping their methods would require proxying
// the classes; revisit if those calls also start dogpiling.

import * as sdk from "@induz/sdk";
import { queued } from "./sdkQueue";

// Pass-throughs (classes / non-fn exports).
export const ManageUser = sdk.ManageUser;
export const Team = sdk.Team;

// File / lifecycle (FilesDashboard).
export const GetFileDetails = queued(sdk.GetFileDetails);
export const GetFileSummary = queued(sdk.GetFileSummary);
export const GetLifecycleEvents = queued(sdk.GetLifecycleEvents);
export const GetVersionHistory = queued(sdk.GetVersionHistory);
export const GetShares = queued(sdk.GetShares);
export const GetPathHistory = queued(sdk.GetPathHistory);
export const GetActorStats = queued(sdk.GetActorStats);
export const GetCountryStats = queued(sdk.GetCountryStats);
export const ListFilesForDashboard = queued(sdk.ListFilesForDashboard);

// Removed-from-logs helpers.
export const GetRemovedUsersFromLogs = queued(sdk.GetRemovedUsersFromLogs);
export const GetRemovedTeamsFromLogs = queued(sdk.GetRemovedTeamsFromLogs);

// User dashboards.
export const UserActivityTimeline = queued(sdk.UserActivityTimeline);
export const UserCountriesAccessedFrom = queued(sdk.UserCountriesAccessedFrom);
export const UserOpCount = queued(sdk.UserOpCount);
export const UserWriteActivity = queued(sdk.UserWriteActivity);
export const UserStorageBreakdown = queued(sdk.UserStorageBreakdown);
export const UserFilesTouched = queued(sdk.UserFilesTouched);
export const UserSharingActions = queued(sdk.UserSharingActions);
export const UserPermissionRecieved = queued(sdk.UserPermissionRecieved);
export const UserDeniedAttempts = queued(sdk.UserDeniedAttempts);
export const UserRiskScore = queued(sdk.UserRiskScore);
export const UserTopContributingSignals = queued(sdk.UserTopContributingSignals);
export const UserAnomalies = queued(sdk.UserAnomalies);
export const UserOverview = queued(sdk.UserOverview);
export const UserTimeHeatmap = queued(sdk.UserTimeHeatmap);

// Team dashboards.
export const TeamActivityTimeline = queued(sdk.TeamActivityTimeline);
export const TeamFilesTouched = queued(sdk.TeamFilesTouched);
export const TeamMembershipChanges = queued(sdk.TeamMembershipChanges);
export const TeamRoleIntersection = queued(sdk.TeamRoleIntersection);
export const TeamMembers = queued(sdk.TeamMembers);

// Summary dashboard.
export const StorageDistribution = queued(sdk.StorageDistribution);
export const AccessByLocation = queued(sdk.AccessByLocation);
export const OperationCountOverTime = queued(sdk.OperationCountOverTime);
export const TopMovers = queued(sdk.TopMovers);
export const ExternalShareTopUsers = queued(sdk.ExternalShareTopUsers);
export const OffHoursRatio = queued(sdk.OffHoursRatio);
export const StoragePlan = queued(sdk.StoragePlan);
export const CollaborationFlow = queued(sdk.CollaborationFlow);
